import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-title q-mb-lg background-gray q-py-lg section-container" }
const _hoisted_2 = { class: "row q-col-gutter-md section-container q-pt-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-9 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "domain-parking__content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle q-mb-md" }, " Instructions for parking set up "),
    /*#__PURE__*/_createElementVNode("p", null, "To add a domain, you have to:"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 1) register a domain at any registrar "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2) go to the DNS editing section "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3) register a CNAME entry for the domain or its subdomain: CNAME запись: *.{ } "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4) select as the Target target for the redirect: tracker.gambeat.io "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 5) add a domain in the interface below or when creating a campaign ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, [
      /*#__PURE__*/_createTextVNode(" When your domain's DNS records are updated, you will be able to use it in links for promotional materials."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Updating DNS records usually takes from a few minutes to 12 hours. ")
    ])
  ])
], -1)
const _hoisted_4 = { class: "col-md-3 col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" })
], -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "ID:", -1)
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Date:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Link:", -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Status:", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDomain = _resolveComponent("AddDomain")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('tools')) + " > " + _toDisplayString(_ctx.$t('parking')), 1),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AddDomain, { onRefresh: _ctx.onRequest }, null, 8, ["onRefresh"])
        ]),
        _hoisted_5
      ]),
      _hoisted_6,
      _createVNode(_component_q_table, {
        rows: _ctx.rows,
        columns: _ctx.columns,
        "row-key": "id",
        flat: "",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
        loading: _ctx.loading,
        onRequest: _ctx.onRequest,
        "binary-state-sort": "",
        "rows-per-page-label": _ctx.$t('rows_per_page'),
        grid: _ctx.$q.screen.width <= 1199
      }, _createSlots({
        "body-cell-name": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: "offer-link underlined text-primary text-weight-bold",
                href: 'https://' + props.row.name,
                target: "_blank"
              }, _toDisplayString(props.row.name), 9, _hoisted_7)
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        _: 2
      }, [
        (_ctx.$q.screen.width <= 1199)
          ? {
              name: "item",
              fn: _withCtx((props) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", null, _toDisplayString(props.row.id), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", null, _toDisplayString(_ctx.format(props.row.updatedAt)), 1)
                    ])
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          class: "offer-link underlined text-primary text-weight-bold",
                          href: 'https://' + props.row.name,
                          target: "_blank"
                        }, _toDisplayString(props.row.name), 9, _hoisted_18)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      (props.row.status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(props.row.status), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, "—"))
                    ])
                  ])
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "rows-per-page-label", "grid"])
    ]),
    _: 1
  }))
}